import React, { useContext, useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import AdminLayout from "../../components/layout/AdminLayout";

import PermissionsTable from "../../components/permissions/PermissionsTable";

import LoadingSpinner from "../../components/utilities/LoadingSpinner";

import UserContext from "../../context/users/userContext";

const AppPermissionsPage = () => {
  const userContext = useContext(UserContext);
  const { users, getUsers, loading } = userContext;

  useEffect(() => {
    getUsers();
  }, []);
  return (
    <AdminLayout>
      <div className="app-permissions-page">
        <div className="container">
          {!loading ? (
            <PermissionsTable
              items={users}
            />
          ) : (
            <LoadingSpinner />
          )}
        </div>
      </div>
    </AdminLayout>
  );
};

export default AppPermissionsPage;
